import ResultTable from "../../Table/ResultTable";
import ResultHeader from "../../Table/ResultHeader";
import ResultBody from "../../Table/ResultBody";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBodyCell from "../../Table/ResultBodyCell";

export default function ExpContUI({riverStation}) {
    const getColor = (cs_name) => {
        if(riverStation.cross_section === cs_name)
            return 'red'

        return ''
    }

    return (
        <div>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: 100}}>
                            River Station
                        </ResultHeaderCell>
                        <ResultHeaderCell style={{width: 100, textAlign: 'right'}}>
                            Con/Exp
                        </ResultHeaderCell>
                        <ResultHeaderCell style={{width: 100, textAlign: 'right'}}>
                            Section
                        </ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    <>
                        {
                            riverStation?.culvert_data?.us_4 && (
                                <ResultRow>
                                    <ResultBodyCell style={{textAlign: 'left'}}>
                                        {riverStation?.culvert_data?.us_4.cross_section}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', color: getColor(riverStation?.culvert_data?.us_4.cross_section)}}>
                                        {riverStation?.culvert_data?.us_4.cont}/{riverStation?.culvert_data?.us_4.exp}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', color: getColor(riverStation?.culvert_data?.us_4.cross_section)}}>
                                        Section 4
                                    </ResultBodyCell>
                                </ResultRow>
                            )
                        }
                        {
                            riverStation?.culvert_data?.us_3 && (
                                <ResultRow>
                                    <ResultBodyCell style={{textAlign: 'left'}}>
                                        {riverStation?.culvert_data?.us_3.cross_section}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', color: getColor(riverStation?.culvert_data?.us_3.cross_section)}}>
                                        {riverStation?.culvert_data?.us_3.cont}/{riverStation?.culvert_data?.us_3.exp}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', color: getColor(riverStation?.culvert_data?.us_3.cross_section)}}>
                                        Section 3
                                    </ResultBodyCell>
                                </ResultRow>
                            )
                        }
                        <ResultRow>
                            <ResultHeaderCell colSpan={3}>
                                {riverStation?.culvert_data?.type} at RS {riverStation?.culvert_data?.cross_section}
                            </ResultHeaderCell>
                        </ResultRow>
                        {
                            riverStation?.culvert_data?.ds_2 && (
                                <ResultRow>
                                    <ResultBodyCell style={{textAlign: 'left'}}>
                                        {riverStation?.culvert_data?.ds_2.cross_section}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', color: getColor(riverStation?.culvert_data?.ds_2.cross_section)}}>
                                        {riverStation?.culvert_data?.ds_2.cont}/{riverStation?.culvert_data?.ds_2.exp}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', color: getColor(riverStation?.culvert_data?.ds_2.cross_section)}}>
                                        Section 2
                                    </ResultBodyCell>
                                </ResultRow>
                            )
                        }
                        {
                            riverStation?.culvert_data?.ds_1 && (
                                <ResultRow>
                                    <ResultBodyCell style={{textAlign: 'left'}}>
                                        {riverStation?.culvert_data?.ds_1.cross_section}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', color: getColor(riverStation?.culvert_data?.ds_1.cross_section)}}>
                                        {riverStation?.culvert_data?.ds_1.cont}/{riverStation?.culvert_data?.ds_1.exp}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right', color: getColor(riverStation?.culvert_data?.ds_1.cross_section)}}>
                                        Section 1
                                    </ResultBodyCell>
                                </ResultRow>
                            )
                        }
                    </>
                </ResultBody>
            </ResultTable>
        </div>
    )
}